import { FC } from "react";

interface ContactsIconSVGProps {
    className?: string;
}

const ContactsIconSVG: FC<ContactsIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M33.0001 38.5C33.0001 34.6102 31.4548 30.8796 28.7043 28.1291C25.9538 25.3786 22.2233 23.8333 18.3334 23.8333M18.3334 23.8333C14.4436 23.8333 10.713 25.3786 7.96252 28.1291C5.21198 30.8796 3.66675 34.6102 3.66675 38.5M18.3334 23.8333C23.396 23.8333 27.5001 19.7293 27.5001 14.6667C27.5001 9.60406 23.396 5.5 18.3334 5.5C13.2708 5.5 9.16675 9.60406 9.16675 14.6667C9.16675 19.7293 13.2708 23.8333 18.3334 23.8333ZM40.3334 36.6667C40.3334 30.4883 36.6667 24.75 33.0001 22C34.2053 21.0957 35.1691 19.9083 35.8061 18.5428C36.4431 17.1773 36.7337 15.6759 36.6521 14.1713C36.5705 12.6667 36.1193 11.2055 35.3385 9.91687C34.5576 8.62824 33.471 7.55198 32.1751 6.78333"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ContactsIconSVG;
